module.exports = __webpack_public_path__ + "static/media/LabourCard.30eb9e4b.svg";